import $ from 'jquery';

import ERROR_MESSAGES from './messages';
import { addValidation } from './validation';

const messages = ERROR_MESSAGES.aussiehomeloans;

function requireInputMaxlength(input) {
  const element = input;
  // No negative values
  if (element.value < 0) {
    element.value = Math.abs(element.value);
  }

  // Set max length (Custom for input type = number)
  let maxlength = element.getAttribute('maxlength');
  if (maxlength) {
    maxlength = Number(maxlength);
    if (element.value.length > maxlength) {
      element.value = element.value.substring(0, maxlength);
    }
  }
}

function isResidencyValid(residency, form) {
  let valid = false;
  if (residency === null) {
    $(form.querySelector('input[name="residency"]')).valid();
  } else if (residency.value === '0') {
    addValidation(
      residency,
      'noResidency',
      value => (value === '1'),
      messages.residency,
    );
    $(residency).valid();
  } else {
    valid = true;
  }

  return valid;
}

/**
 * Requires max length and validates using tenDigitPhoneCustom format
 */
function checkPhone(element) {
  requireInputMaxlength(element);
  $(element).rules('add', { tenDigitPhoneCustom: true });
  $(element).valid();
}

/**
 * Event: On change
 */
function checkLoanPurpose(select) {
  const selectedValue = select.options[select.selectedIndex].value;
  const { studentLoan, other } = messages.loanPurpose;

  if (selectedValue === 'Other' || selectedValue === 'Student loan') {
    addValidation(
      select,
      'invalidLoanPurpose',
      value => (value !== 'Other' && value !== 'Student loan'),
      selectedValue === 'Other' ? other : studentLoan,
    );
  }
  $(select).valid();
}

/**
 * Event: On form submit
 */
function checkFormSubmission(form) {
  // Check residency
  const residency = form.querySelector('input[name="residency"]:checked');
  let submit = isResidencyValid(residency, form);

  // Loan purpose must not be Other or Student loan
  const purpose = form.querySelector('#loan_purpose');
  const selectedValue = purpose.options[purpose.selectedIndex].value;
  if (selectedValue === 'Other' || selectedValue === 'Student loan') {
    submit = false;
  }

  return submit;
}

export default {
  checkFormSubmission,
  checkLoanPurpose,
  checkPhone,
  requireInputMaxlength,
};
